export const SEODescription =
  'Mylo It takes a village to raise a child. A couple with a newborn child n  takes a village to raise a child. A couple with a newborn child n takes a village to raise a child.abc bcd cdn uhjja jbajaaa';
export const FAQCategoryConstant = [
  {
    questionName:
      'I m breastfeeding my baby can I use this ...or will it effect my baby',
    acceptedAnswerText:
      "You can use it without any worry, it won't harm the baby in any way",
  },
  {
    questionName:
      "Can I use it during pregnancy as well? I am 6 months pregnant and could see lot of stretch marks around my belly, legs and hands. Please suggest if it is safe to use over lower abdomen and won't effect womb.",
    acceptedAnswerText: 'Yes it is safe to use during pregnancy ',
  },
  {
    questionName: 'Kya delivery k 6 month baad use kr skte h',
    acceptedAnswerText:
      'Yes, Maine delivery ke 4 month baad shuru kiya. 3-4 hafte mai asar dikhna shuru hua par hogya. ',
  },
  {
    questionName: 'Delivery k kitne din baad hum isko use kr sakte hein',
    acceptedAnswerText: 'Pregnancy se he use kar sakte hain',
  },
  {
    questionName:
      'Can this stretch marks crean help to remove itchiness on the skin?',
    acceptedAnswerText: 'Yes it will remove itchiness also',
  },
];

export const clothDiaperFAQ = [
  {
    question: 'How many diapers does a newborn baby need?',
    answer:
      "Every day, a baby uses an average of 10 to 12 diapers in the first month. That means your baby will use about 300 diapers in their first month! A 2–3-day supply of diapers is a good starting point. This amount will depend on your baby's age, your washing habits, and the type of cloth diapers you use.However, we recommend at least 36 diapers for newborns, 24 for infants, and 20 for toddlers for one month.",
  },
  {
    question: 'What size mylo cloth diapers do I need ?',
    answer:
      'Mylo cloth diaper is adjustable diapers that fit babies aged 3 months to 3 years. ',
  },
  {
    question: 'How long can babies use cloth diapers ?',
    answer:
      'Cloth diapers can also be used for an average of two to three years, probably longer if you take good care of them.Cloth diapers need to be washed every two to three days to avoid odour and stain problems.',
  },
  {
    question: 'Do you really save money with cloth diapers ?',
    answer:
      'Cloth diapers are generally cheaper than disposable diapers when you add up the cost for the entire time a baby is diapered.You can save a lot more by ditching the expensive disposable wipes and using cloth wipes at home instead.',
  },
  {
    question: 'Do babies feel wet in cloth diapers ?',
    answer:
      'Yes, babies might feel wet in diapers if not changed after every 4 - 5 hours for an average wetting baby.',
  },
  {
    question: 'Do you change a cloth diaper after every pee ?',
    answer:
      'No, cloth diapers are super- absorbent.You should change a cloth diaper when they start to feel heavy or after 5 - 6 hours.',
  },
  {
    question: 'When should I start cloth diapering ?',
    answer:
      'You can start using cloth diapers for your baby 3 month onwards and continue till 3 years.',
  },
  {
    question: 'Is it okay to wash cloth diapers with other clothes ?',
    answer:
      'You can wash reusable diapers in your washing machine but try not to mix them with other clothes.Give a quick rinse to soiled cloth diapers before adding them to the machine.',
  },
  {
    question: 'Are newborn cloth nappies worth it ?',
    answer:
      'Absolutely, cloth diapers or washable diapers last much longer and cost much less compared to disposable diapers.Plus, they don’t contain any chemicals.',
  },
  {
    question: 'Can I wash cloth diapers in cold water ?',
    answer:
      'Yes, you can wash cloth diapers in cold water.However, to get rid of any stains or smell, it’s best to wash them in warm or hot water.',
  },
  {
    question: 'Are reusable diapers safe for the baby’s skin ?',
    answer:
      'Yes, reusable or washable diapers are absolutely safe for your baby’s skin.They are toxin - free and made with safe fabrics.',
  },
];

export const revalidate_1_hour = 3600;
export const revalidate_5_minutes = 300;
export const revalidate_15_minutes = 900;
